import * as React from 'react';
import {
  Autocomplete,
  FormControl,
  TextField,
  type TextFieldProps,
  type AutocompleteProps,
} from '@mui/material';
import { type SelectOption } from '../Select';

export type SearchableSelectProps = TextFieldProps &
  Omit<
    AutocompleteProps<string | number, false, false, true, 'div'>,
    'renderInput' | 'options'
  > & {
    options: SelectOption[];
    name?: string;
    autoComplete?: boolean;
    onChange: any;
    onFocus?: any;
    onBlur?: any;
    inputLabelProps?: any;
  };

export const SearchableSelect: React.FunctionComponent<
  SearchableSelectProps
> = (props: SearchableSelectProps) => {
  const {
    options,
    name,
    autoComplete,
    onChange, // to override the onChange in order to fit formik
    onFocus,
    onBlur,
    label,
    id,
    error,
    helperText,
    inputLabelProps,
    value,
    disabled = false,
    required,
    fullWidth,
    ...rest
  } = props;

  const handleInputChange = (event: any, inputValue: any): void => {
    onChange({
      target: {
        name,
        value: inputValue,
      },
    });
  };

  return (
    <FormControl error={Boolean(helperText)} fullWidth>
      <Autocomplete
        {...rest}
        freeSolo
        renderInput={params => (
          <TextField
            {...params}
            name={name}
            label={label}
            required={required}
            disabled={disabled}
            error={error}
            onBlur={onBlur}
            slotProps={{ inputLabel: inputLabelProps }}
            helperText={helperText}
          />
        )}
        options={options.map(option => option.value)}
        onInputChange={handleInputChange}
        onChange={handleInputChange}
        value={value}
        disabled={disabled}
      />
    </FormControl>
  );
};
